<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <div slot="header" class="clearfix">
        <div class="flex-between" style="flex-wrap: nowrap;">
          <el-form :model="searchForm" ref="searchForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="货品搜索：" prop="name">
              <el-input class="mt-search-width" v-model="searchForm.name" placeholder="请输入货品编号/货品名称搜索"></el-input>
              <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
            </el-form-item>
          </el-form>
          <el-button @click="syncGoodsSpecDataBtn" v-loading.fullscreen.lock="fullscreenLoading" type="primary">数据同步</el-button>
        </div>
      </div>
      <div class="text item">
        <el-table
          border
          :data="infoList">
          <el-table-column
            align="center"
            prop="apiGoodsNo"
            label="货品编号">
          </el-table-column>
          <el-table-column
            align="center"
            prop="apiGoodsName"
            label="货品名称">
          </el-table-column>
          <el-table-column
            align="center"
            width="210"
            label="操作">
            <template slot-scope="scope">
              <el-button @click="detailBtn(scope.row.apiGoodsId)" type="text" size="small">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { queryPlatformGoodsPageList, syncGoodsSpecData } from '@/api/goods'
export default {
  name: 'ShopPlatformList',
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      pageTotal: 1,
      currentPage: 1,
      infoList: [],
      fullscreenLoading: false,
      searchForm: {
        name:''
      }
    }
  },
  mounted () {
    this.currentPage = Number(this.$route.query.page) || 1
    this.getInfoList()
  },
  methods: {
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let searchName = that.searchForm.name
      let page = that.currentPage
      queryPlatformGoodsPageList({ searchStr: searchName, pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      // 更新路由参数保存页码
      this.$router.replace({
        query: {
          ...this.$route.query,
          page: val.page
        }
      })
      this.getInfoList();
    },
    /* 详情 */
    detailBtn (infoId) {
      this.$router.push({path: '/shop_platform_detail', query: {dataId: infoId}})
    },
    // 同步数据操作
    syncGoodsSpecDataBtn(){
      var that = this;
      that.fullscreenLoading = true;
      syncGoodsSpecData().then((res) => {
        that.fullscreenLoading = false;
        if (res.errorCode === '0000') {
          that.$message.success(res.msg);
          that.countUpdateNum = that.countUpdateNum+'.'+that.tabCurrent
          that.$emit('countUpdateNumStatus', that.countUpdateNum);
          that.getInfoList();
        }
        if (res.errorCode === '1001') {
          that.$message.error(res.msg);
        }
      });
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/goods/platform/List.vue